/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} World_Switcher_Error_TitleInputs */

const en_world_switcher_error_title = /** @type {(inputs: World_Switcher_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch failed`)
};

const fr_world_switcher_error_title = /** @type {(inputs: World_Switcher_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bascule échouée`)
};

const ms_sg2_world_switcher_error_title = /** @type {(inputs: World_Switcher_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penukaran gagal`)
};

/**
* | output |
* | --- |
* | "Switch failed" |
*
* @param {World_Switcher_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const world_switcher_error_title = /** @type {((inputs?: World_Switcher_Error_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<World_Switcher_Error_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_world_switcher_error_title(inputs)
	if (locale === "fr") return fr_world_switcher_error_title(inputs)
	return ms_sg2_world_switcher_error_title(inputs)
});